import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";




export default function StripeSetupCompletedPopup({ }) {
    const navigate = useNavigate();

    useEffect(() => {
        const modal: any = $('#stripeSetupCompleted');
        modal.modal('show');
    }, []);

    return (
        <div className="modal fade inner-modal com-modal" id="stripeSetupCompleted" tabIndex={-1} aria-labelledby="stripeSetupCompletedLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false" >
            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable" >
                <div className="modal-content">
                    <div className="modal-header">
                        <h1 className="modal-title" id="stripeSetupCompletedLabel">Stripe Setup</h1>
                        <button
                            type="button"
                            className="btn-close position-absolute top-0 end-0 m-3"
                            aria-label="Close"
                        />
                    </div>
                    <div className="modal-body">
                        {/* Success image */}
                        <div className='success-tick'>
                            <svg width="100" height="100" viewBox="0 0 100 100">
                                <circle
                                    fill="none"
                                    stroke="#198754"
                                    strokeWidth="9"
                                    cx="50"
                                    cy="50"
                                    r="45"
                                    strokeLinecap="round"
                                    transform="rotate(-90 50 50)"
                                    className="circle"
                                />
                                <polyline
                                    fill="none"
                                    stroke="#198754"
                                    points="22,53 43,71 76,34"
                                    strokeWidth="9"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="tick"
                                />
                            </svg>
                        </div>

                        {/* Title */}
                        <h2 className="fw-bold text-success mb-2 mt-3">Stripe Setup Completed 🎉</h2>

                        {/* Message */}
                        <p className="text-muted">
                            Your Stripe account has been successfully connected.
                            <br />
                            You can now start receiving payments securely.
                        </p>

                        {/* CTA button */}
                        <button
                            className="btn btn-primary mt-3 px-4"
                            onClick={() => {
                                const modal: any = $('#stripeSetupCompleted');
                                modal.modal('hide');
                                navigate("/dashboard");

                            }}
                        >
                            Go to Dashboard
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )

    // return (
    //     <div
    //         className="modal-backdrop-custom"
    //         onClick={onClose} // close when clicking outside
    //     >
    //         <div
    //             className="modal-content-custom"
    //             onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside
    //         >
    //             {/* Close button */}
    //             <button
    //                 type="button"
    //                 className="btn-close position-absolute top-0 end-0 m-3"
    //                 aria-label="Close"
    //                 onClick={onClose}
    //             />

    //             {/* Success image */}
    //             <div className='success-tick'>
    //                 <svg width="100" height="100" viewBox="0 0 100 100">
    //                     <circle
    //                         fill="none"
    //                         stroke="#198754"
    //                         strokeWidth="9"
    //                         cx="50"
    //                         cy="50"
    //                         r="45"
    //                         strokeLinecap="round"
    //                         transform="rotate(-90 50 50)"
    //                         className="circle"
    //                     />
    //                     <polyline
    //                         fill="none"
    //                         stroke="#198754"
    //                         points="22,53 43,71 76,34"
    //                         strokeWidth="9"
    //                         strokeLinecap="round"
    //                         strokeLinejoin="round"
    //                         className="tick"
    //                     />
    //                 </svg>
    //             </div>

    //             {/* Title */}
    //             <h2 className="fw-bold text-success mb-2 mt-3">Stripe Setup Completed 🎉</h2>

    //             {/* Message */}
    //             <p className="text-muted">
    //                 Your Stripe account has been successfully connected.
    //                 <br />
    //                 You can now start receiving payments securely.
    //             </p>

    //             {/* CTA button */}
    //             <button
    //                 className="btn btn-primary mt-3 px-4"
    //                 onClick={() => {
    //                     onClose();
    //                     navigate("/dashboard");
    //                 }}
    //             >
    //                 Go to Dashboard
    //             </button>
    //         </div>
    //     </div>
    // );
}
